<div class="file-not-found">

  <header>
    <h1>Fichier non trouvé</h1>
    <h2 *ngIf="fileName$ | async">
      {{ fileName$ | async }}
    </h2>
  </header>

  <div class="subtitle">
    <div *ngIf="deleted$ | async">
      Le fichier a été supprimé
    </div>
    <div *ngIf="!(deleted$ | async)"
    >
      Le fichier que vous avez demandé n'a pas été trouvé.
    </div>
  </div>

  <div class="details">
    <div class="message" *ngIf="error$">
      <label>Message:</label>
      <span>{{ error$ | async }}</span>
    </div>
    <div class="ref" *ngIf="ref$ | async">
      <label>Ref:</label>
      <span>{{ ref$ | async }}</span>
    </div>
    <div class="fileId" *ngIf="fileId$ | async">
      <label>Id:</label>
      <span>{{ fileId$ | async }}</span>
    </div>
  </div>

  <p>
    Le problème a été rapporté. Vous pouvez fermer cette page ou revenir à la page précédente.
  </p>

</div>
